export const MARTECH_BANNER_STONE_EXPERIMENT = 'martech_banner_on_map_in_commercial_for_sp_stone';
export const AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC = 'aud_mobile_bx1047_single_pin_logic';
export const AUD_WEB_BX1122_PIN_UNIFICATION = 'aud_web_bx1122_pin_unification';

export const EXPERIMENTS: string[] = [
  MARTECH_BANNER_STONE_EXPERIMENT,
  AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC,
  AUD_WEB_BX1122_PIN_UNIFICATION,
];
